<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <!-- <ServerError v-if="ServerError" /> -->
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card flat>
          <v-flex xs12>
            <v-card color="#434343" outlined>
              <v-layout justify-center wrap py-5 v-if="customers">
                <v-flex xs12 sm12 md12 text-center>
                  <v-layout justify-center wrap>
                    <v-flex xs12 v-if="customers.customerid">
                      <v-avatar
                        style="cursor: pointer"
                        size="80"
                        v-if="customers.customerid.photo"
                      >
                        <v-img :src="mediaURL + customers.customerid.photo" />
                      </v-avatar>
                    </v-flex>
                    <v-flex xs12 pt-1>
                      <span
                        v-if="customers.customerid"
                        style="
                          color: #ffffff;
                          font-family: nunitosanssemibold;
                          font-size: 18px;
                        "
                        >{{ customers.customerid.firstName }}
                        {{ customers.customerid.lastName }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-layout justify-center wrap v-if="customers.customerid">
            <v-flex xs12>
              <v-card-text>
                <v-layout justify-start wrap py-5>
                  <v-flex text-left xs12 sm12 md12>
                    <span
                      style="
                        color: #000000;
                        font-family: nunitosansbold;
                        font-size: 18px;
                      "
                      >Personal Information</span
                    >
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2>
                        <v-img
                          width="25px"
                          src="./../../../assets/images/male black 24dp.png"
                        />
                      </v-flex>
                      <v-flex text-left xs10 sm10 md10>
                        <span class="heading">Gender</span>
                        <br />
                        <span
                          class="content"
                          v-if="customers.customerid.gender"
                          >{{ customers.customerid.gender }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2 pt-2>
                        <v-img
                          width="25px"
                          src="./../../../assets/images/phone iphone black 24dp.png"
                        />
                      </v-flex>
                      <v-flex xs10 sm10 md10>
                        <span class="heading">Contact</span>
                        <br />
                        <span class="content">{{ customers.phone }}</span>
                        <br />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2 pt-2>
                        <v-img
                          width="25px"
                          src="./../../../assets/images/email black 24dp.png"
                        />
                      </v-flex>
                      <v-flex xs10 sm10 md10>
                        <span class="heading">Email</span>
                        <br />
                        <span class="content">{{
                          customers.customerid.email
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2>
                        <v-img
                          width="25px"
                          src="./../../../assets/images/home black 24dp.png"
                        />
                      </v-flex>
                      <v-flex xs10 sm10 md10>
                        <span class="heading">Address</span>
                        <br />
                        <span
                          class="content"
                          v-if="customers.customerid.address"
                          >{{ customers.customerid.address }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2 pt-2>
                        <v-icon color="#8b8b8b">mdi-map-marker</v-icon>
                      </v-flex>
                      <v-flex xs10 sm10 md10>
                        <span class="heading">Pincode</span>
                        <br />
                        <span class="content">{{
                          customers.customerid.pincode
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex text-left xs12 sm6 md4>
                    <v-layout justify-center wrap py-5>
                      <v-flex xs2 sm2 md2>
                        <v-img
                          width="25px"
                          src="./../../../assets/images/home black 24dp.png"
                        />
                      </v-flex>
                      <v-flex xs10 sm10 md10>
                        <span class="heading">Landmark</span>
                        <br />
                        <span
                          class="content"
                          v-if="customers.customerid.landmark"
                          >{{ customers.customerid.landmark }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <!-- <v-flex xs12 sm12 md6 text-right>
                        <v-dialog v-model="editdialog" max-width="700px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="16" v-bind="attrs" v-on="on"
                              >mdi-folder-edit-outline</v-icon
                            >
                          </template>
                          <v-card>
                            <v-card-text>
                              <v-layout justify-start wrap pt-5>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="customers.name"
                                    class="text"
                                    label="Last Name"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-select
                                    dense
                                    label="Gender"
                                    outlined
                                    class="text"
                                    v-model="customers.gender"
                                    hide-details
                                    :items="genders"
                                  >
                                  </v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="customers.dob"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="customers.dob"
                                        label="DOB"
                                        readonly
                                        outlined
                                        dense
                                        v-bind="attrs"
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="customers.dob"
                                      max="2000-01-1"
                                      no-title
                                      scrollable>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false">
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(customers.dob)">
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="customers.email"
                                    class="text"
                                    label="Email"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6 pa-2>
                                  <v-text-field
                                    v-model="customers.phone"
                                    class="text"
                                    label="Contact"
                                    outlined
                                    type="number"
                                    dense
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 pa-2>
                                  <v-text-field
                                    v-model="customers.address"
                                    class="text"
                                    label="Address"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-layout justify-center wrap>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    block
                                    tile
                                    color="#757575"
                                    outlined
                                    :ripple="false"
                                    depressed
                                    @click="editdialog = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-flex>
                                <v-flex xs6 sm4 px-2>
                                  <v-btn
                                    tile
                                    block
                                    dark
                                    color="#FF1313"
                                    depressed
                                    class="text-capitalize"
                                    :ripple="false"
                                    @click="edit()"
                                  >
                                    Save
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <span
                          style="
                            font-family: nunitosansregular;
                            font-size: 12px;"
                          >Edit Information</span
                        >
                      </v-flex> -->
                </v-layout>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 pb-8>
        <v-layout wrap>
          <v-flex xs12 align-self-center text-center py-6>
            <span class="headds">My Orders</span>
          </v-flex>
          <v-flex xs12 md12 v-if="myOrders && totalCount > 0">
            <v-layout wrap pb-3>
              <v-flex sm6 md3 v-for="(item, i) in myOrders" :key="i">
                <v-card
                  v-if="i < 8"
                  height="300px"
                  py-4
                  flat
                  :to="'OrderInfo?order=' + item._id"
                >
                  <v-layout wrap justify-center text-center px-10>
                    <v-flex xs12 pb-2 v-if="item.photos.length > 0">
                      <v-card height="200" tile flat>
                        <div style="margin: 0; height: 100%">
                          <Collage
                            :images="item.photos"
                            style="object:fit:contain!important"
                            :collageSizeMin="1"
                            :collageSizeMax="4"
                            :showNoImagesMsg="true"
                            noImagesMsg="No Images"
                            :showLoadingMsg="false"
                            loadingMsg="Loading..."
                            height="200px"
                          >
                          </Collage>
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 pb-2 v-else>
                      <v-img
                        height="200"
                        contain
                        :src="require('./../../../assets/images/no-image.png')"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span
                            v-for="(items, index) in item.products"
                            :key="index"
                            style="font-family: poppinsregular; font-size: 14px"
                          >
                            <span v-if="index <= 1">
                              {{ items.name }}
                              <span v-if="index < item.products.length - 1"
                                >,</span
                              >
                            </span>
                          </span>
                          <span v-if="item.products.length > 2">...</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-1>
                      <span style="font-weight: bold">
                        Rs. {{ item.totalAmount }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else>
            <span class="">No Orders Found!!!</span>
          </v-flex>
          <v-flex xs12 text-center pb-8 px-2 v-if="totalCount > 8">
            <v-btn
              tile
              outlined
              :width="$vuetify.breakpoint.name == 'lg' || 'md' ? '20%' : '100%'"
              :to="'myorders?customer=' + $route.query.customer"
            >
              <span class="RB">VIEW ALL ORDERS</span>
            </v-btn>
          </v-flex>

          <v-flex xs12 align-self-center text-center py-6>
            <span class="headds">Grocery Orders</span>
          </v-flex>
          <v-flex xs12 md12 v-if="groceryorders && totalCount > 0">
            <v-layout wrap pb-3>
              <v-flex sm6 md3 v-for="(item, i) in groceryorders" :key="i">
                <v-card
                  v-if="i < 8"
                  height="300px"
                  py-4
                  flat
                  :to="'GroceryOrderInfo?order=' + item._id"
                >
                  <v-layout wrap justify-center text-center px-10>
                    <v-flex xs12 pb-2 v-if="item.photos.length > 0">
                      <v-card height="200" tile flat>
                        <div style="margin: 0; height: 100%">
                          <Collage
                            :images="item.photos"
                            style="object:fit:contain!important"
                            :collageSizeMin="1"
                            :collageSizeMax="4"
                            :showNoImagesMsg="true"
                            noImagesMsg="No Images"
                            :showLoadingMsg="false"
                            loadingMsg="Loading..."
                            height="200px"
                          >
                          </Collage>
                        </div>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 pb-2 v-else>
                      <v-img
                        height="200"
                        contain
                        :src="require('./../../../assets/images/no-image.png')"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs12>
                          <span
                            v-for="(items, index) in item.products"
                            :key="index"
                            style="font-family: poppinsregular; font-size: 14px"
                          >
                            <span v-if="index <= 1">
                              {{ items.productName }}
                              <span v-if="index < item.products.length - 1"
                                >,</span
                              >
                            </span>
                          </span>
                          <span v-if="item.products.length > 2">...</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 pt-1>
                      <span style="font-weight: bold">
                        Rs. {{ item.totalAmount }}
                      </span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-else>
            <span class="">No Orders Found!!!</span>
          </v-flex>
          <v-flex xs12 text-center pb-8 px-2 v-if="totalCount > 8">
            <v-btn
              tile
              outlined
              :width="$vuetify.breakpoint.name == 'lg' || 'md' ? '20%' : '100%'"
              :to="'GroceryListPage?customer=' + $route.query.customer"
            >
              <span class="RB">VIEW ALL ORDERS</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 py-3>
        <span class="headds">Customer Location</span>
      </v-flex>
      <v-flex xs12>
        <div id="mappz"></div>
      </v-flex>
    </v-layout>
  </div>
</template>


<script
 src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBaUVPtkwXGFXPy05pSXVx0Y7QmGj-P-ls&callback=initMap&libraries=&v=weekly">
</script>
<script>
// import ImageLoader from "@/components/Common/imageLoader";
import axios from "axios";
import Collage from "vue-collage";

export default {
  components: {
    Collage,
  },
  data() {
    return {
      currentPage: 1,
      customers: [],
      groceryorders: [],
      myOrders: [],
      totalCount: 0,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      splitUrl: "",
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 4, nav: false },
      },
      mapData: [],
      latt: 0,
      lonn: 0,
      map3: null,
      marker: [],
      verifyDelete: false,
      keepStatus: "",
      notice: "",
      isReject: false,
      validates: false,
      reason: "",
      req: {
        required: (value) => !!value || "Required.",
      },
      maps: null,
      flag: false,
    };
  },
  watch: {
    currentPage() {
      // this.getData();
      this.getProduct();
    },
  },
  beforeMount() {
    if (this.$route.query.customer) {
      this.getData();
      this.getProduct();
      this.getgrocery();
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      this.map3 = new google.maps.Map(document.getElementById("mappz"), {
        center: { lat: 22.5937, lng: 78.96 },
        zoom: 9,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      });
    },
    mark(event) {
      console.log("eve", event);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      console.log("mark lt is", this.latt);
      console.log("mark ln is", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
      console.log("marker =", this.latt);
    },

    getgrocery() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/admin/orders/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.query.customer,
          limit: 12,
          page: 1,
        },
      })
        .then((response) => {
          if (response.data.status) {
            var groceryorders = [];
            groceryorders = response.data.data;
            var vm = this;
            for (var i = 0; i < groceryorders.length; i++) {
              if (groceryorders[i].photos.length > 0) {
                var photos = [];

                photos = groceryorders[i].photos;
                photos.map(function (obj) {
                  obj.image = vm.mediaURL + obj.image;
                  return obj;
                });
                groceryorders[i].photos = photos;
              }
            }
            this.groceryorders = groceryorders;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/view/" + this.$route.query.customer,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.customers = response.data.data;

            this.latt = this.customers.location[1];
            this.lonn = this.customers.location[0];
            // console.log(this.lonn);
            this.map3 = new google.maps.Map(document.getElementById("mappz"), {
              center: { lat: this.latt, lng: this.lonn },
              zoom: 20,
              mapTypeId: google.maps.MapTypeId.HYBRID,
              // tilt: 170
            });

            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.map3,
            });
            this.pages = response.data.pages;
            // if (this.sellers.sellerProfileId.videoUrl)
            //   this.cutVideo(this.sellers.sellerProfileId.videoUrl);
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.query.customer,
        },
      })
        .then((response) => {
          if (response.data.status) {
            var myOrders = [];
            myOrders = response.data.data;
            var vm = this;
            for (var i = 0; i < myOrders.length; i++) {
              if (myOrders[i].photos.length > 0) {
                var photos = [];

                photos = myOrders[i].photos;
                photos.map(function (obj) {
                  obj.image = vm.mediaURL + obj.image;
                  return obj;
                });
                myOrders[i].photos = photos;
              }
            }
            this.myOrders = myOrders;
            this.totalCount = response.data.totalLength;
            // this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    verifyStatus(status) {
      this.verifyDelete = true;
      this.keepStatus = status;
      if (status == "approve")
        this.notice = "Do you want to approve this request?";
      else if (status == "reject") {
        this.isReject = true;
        this.notice = "Do you want to reject this request?";
      }
    },
    updateStatus(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/approve/reject",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.seller,
          action: status,
          rejectReason: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.getData();
            this.verifyDelete = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    cutVideo(eve) {
      let b = "https://www.youtube.com/embed/";
      // this.programs.video[0]
      // this.splitUrl(eve.replace("https://youtu.be/", embed));
      var em = eve.replace("https://youtu.be/", b);
      this.splitUrl = em;
      // console.log(this.splitUrl);
    },
  },
};
</script>

<style  scoped>
#mappz {
  height: 400px;
  /* The height is 400 pixels */
  width: 100%;
  /* The width is the width of the web page */
}
</style>